import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";
import WhatsAppButton from "../components/WhatsAppButton";
import LandingChatbot from "../components/LandingChatbot";
import { Helmet } from "react-helmet";
import useFacebookPixel from "../hooks/useFacebookPixel";
import SocialButtons from "../components/SocialButton";
import MicrosoftClarity from '../components/MicrosoftClarity';
import "./usuario.css";
import "./recuadro.css";
import "./AudienciaLanding.css";

const RevelacionLanding = () => {
  const { usuario } = useParams();
  useFacebookPixel(usuario);
  const { trackContact } = useFacebookPixel(usuario);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [userdata, setUserdata] = useState({});
  const [Pixels, setPixels] = useState("");
  const [Clarity, setClarity] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://api.mrcirp.com/public/usuariolanding/${usuario}`
        );
        if (response.data && response.data.length > 0) {
          setData(response.data[0]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchUserInfo = async () => {
      try {
        const response = await axios.get(
          `https://api.mrcirp.com/public/infocampanas/${usuario}`
        );
        setUserdata(response.data[0]);
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    const pixelsuser = async () => {
      try {
        const response = await axios.get(
          `https://api.mrcirp.com/public/userpixels/${usuario}`
        );
        setPixels(response.data[0]);
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    const clarityuser = async () => {
      try {
        const response = await axios.get(
          `https://api.mrcirp.com/public/userclarity/${usuario}`
        );
        setClarity(response.data[0]);
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    fetchData();
    fetchUserInfo();
    pixelsuser();
    clarityuser();
  }, [usuario]);

  if (!data) {
    return <div>Loading...</div>;
  }

  const hasAnySocialLink = 
    (userdata && userdata.pdf) || 
    (userdata && userdata.facebook) || 
    (userdata && userdata.instagram) || 
    (userdata && userdata.linkedin) || 
    (userdata && userdata.tiktok) || 
    (userdata && userdata.calendly);

  // Parsear servicios_items de revelación
  let revelacionServiciosItems = [];
  if (data.revelacion_servicios_items) {
    try {
      revelacionServiciosItems = typeof data.revelacion_servicios_items === 'string' 
        ? JSON.parse(data.revelacion_servicios_items) 
        : data.revelacion_servicios_items;
      if (!Array.isArray(revelacionServiciosItems)) revelacionServiciosItems = [];
    } catch (e) {
      console.error('Error parsing revelacion_servicios_items:', e);
    }
  }

  return (
    <div style={styles.container}>
      <Helmet>
        <title>{usuario} - Revelación</title>
        <meta name="description" content={`Pixels: ${Pixels}`} />
      </Helmet>
      {Clarity?.clarity && <MicrosoftClarity trackingId={Clarity.clarity} />}
      
      {/* Banner Section */}
      <div 
        style={{
          ...styles.bannerSection,
          backgroundImage: data.revelacion_banner_imagen_url ? `url(${data.revelacion_banner_imagen_url})` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          minHeight: 'auto',
          paddingBottom: '60px'
        }}
      >
        <div style={styles.content}>
          {(data.revelacion_banner_titulo || data.revelacion_banner_subtitulo) && (
            <div style={styles.bannerContent}>
              {data.revelacion_banner_titulo && (
                <h1 
                  style={styles.bannerTitle}
                  dangerouslySetInnerHTML={{ __html: data.revelacion_banner_titulo }}
                />
              )}
              {data.revelacion_banner_subtitulo && (
                <p 
                  style={styles.bannerSubtitle}
                  dangerouslySetInnerHTML={{ __html: data.revelacion_banner_subtitulo }}
                />
              )}
            </div>
          )}
        </div>
      </div>

      {/* Sección de Videos de Revelación */}
      <section className="servicios-section" style={{ padding: '80px 20px' }}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Videos de Revelación</h2>
          </div>
          <div style={styles.videosGrid}>
            {data.urlvideoproducto1 && (
              <div style={styles.videoCard}>
                <div style={styles.videoWrapper}>
                  <ReactPlayer
                    url={data.urlvideoproducto1}
                    width="100%"
                    height="100%"
                    controls={true}
                  />
                </div>
                <button 
                  style={styles.videoButton}
                  onClick={() => navigate(`/producto1/${usuario}`)}
                >
                  Ver más información del Producto 1
                </button>
              </div>
            )}
            {data.urlvideoproducto2 && (
              <div style={styles.videoCard}>
                <div style={styles.videoWrapper}>
                  <ReactPlayer
                    url={data.urlvideoproducto2}
                    width="100%"
                    height="100%"
                    controls={true}
                  />
                </div>
                <button 
                  style={styles.videoButton}
                  onClick={() => navigate(`/producto2/${usuario}`)}
                >
                  Ver más información del Producto 2
                </button>
              </div>
            )}
            {data.urlvideoproducto3 && (
              <div style={styles.videoCard}>
                <div style={styles.videoWrapper}>
                  <ReactPlayer
                    url={data.urlvideoproducto3}
                    width="100%"
                    height="100%"
                    controls={true}
                  />
                </div>
                <button 
                  style={styles.videoButton}
                  onClick={() => navigate(`/producto3/${usuario}`)}
                >
                  Ver más información del Producto 3
                </button>
              </div>
            )}
            {data.urlcomounirsecliente && (
              <div style={styles.videoCard}>
                <div style={styles.videoWrapper}>
                  <ReactPlayer
                    url={data.urlcomounirsecliente}
                    width="100%"
                    height="100%"
                    controls={true}
                  />
                </div>
                <button 
                  style={styles.videoButton}
                  onClick={() => navigate(`/unirsecliente/${usuario}`)}
                >
                  Ver más información para Unirse como Cliente
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Sección de Servicios */}
      {data.revelacion_servicios_titulo && (
        <section 
          className="servicios-section"
          style={{
            backgroundImage: data.revelacion_servicios_fondo_imagen ? `url(${data.revelacion_servicios_fondo_imagen})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="container">
            <div className="section-header">
              <h2 
                className="section-title"
                dangerouslySetInnerHTML={{ __html: data.revelacion_servicios_titulo || '' }}
              />
              {data.revelacion_servicios_descripcion && (
                <p 
                  className="section-description"
                  dangerouslySetInnerHTML={{ __html: data.revelacion_servicios_descripcion }}
                />
              )}
            </div>
            
            {revelacionServiciosItems.length > 0 && (
              <div className="servicios-grid">
                {revelacionServiciosItems.map((item, index) => (
                  <div key={index} className="servicio-card">
                    <h3 
                      className="servicio-title"
                      dangerouslySetInnerHTML={{ __html: item.titulo || '' }}
                    />
                    <p 
                      className="servicio-description"
                      dangerouslySetInnerHTML={{ __html: item.descripcion || '' }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      )}

      {/* Sección de Dos Columnas (Imagen Izquierda) */}
      {data.revelacion_dos_columnas_titulo && (
        <section 
          className="dos-columnas-section"
          style={{
            backgroundImage: data.revelacion_dos_columnas_fondo_imagen ? `url(${data.revelacion_dos_columnas_fondo_imagen})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="container">
            <div className="dos-columnas-content">
              <div className="column-left">
                {data.revelacion_dos_columnas_imagen && (
                  <div className="image-container">
                    <img 
                      src={data.revelacion_dos_columnas_imagen} 
                      alt={data.revelacion_dos_columnas_titulo}
                      className="section-image"
                    />
                  </div>
                )}
              </div>
              <div className="column-right">
                <h2 
                  className="section-title"
                  dangerouslySetInnerHTML={{ __html: data.revelacion_dos_columnas_titulo || '' }}
                />
                {data.revelacion_dos_columnas_descripcion && (
                  <p 
                    className="section-description"
                    dangerouslySetInnerHTML={{ __html: data.revelacion_dos_columnas_descripcion }}
                  />
                )}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Sección de Dos Columnas (Imagen Derecha) */}
      {data.revelacion_dos_columnas_derecha_titulo && (
        <section 
          className="dos-columnas-section reverse"
          style={{
            backgroundImage: data.revelacion_dos_columnas_derecha_fondo_imagen ? `url(${data.revelacion_dos_columnas_derecha_fondo_imagen})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="container">
            <div className="dos-columnas-content">
              <div className="column-right">
                <h2 
                  className="section-title"
                  dangerouslySetInnerHTML={{ __html: data.revelacion_dos_columnas_derecha_titulo || '' }}
                />
                {data.revelacion_dos_columnas_derecha_descripcion && (
                  <p 
                    className="section-description"
                    dangerouslySetInnerHTML={{ __html: data.revelacion_dos_columnas_derecha_descripcion }}
                  />
                )}
              </div>
              <div className="column-left">
                {data.revelacion_dos_columnas_derecha_imagen && (
                  <div className="image-container">
                    <img 
                      src={data.revelacion_dos_columnas_derecha_imagen} 
                      alt={data.revelacion_dos_columnas_derecha_titulo}
                      className="section-image"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Footer */}
      <footer className="landing-footer">
        <div className="container">
          <div className="footer-content">
            <p className="footer-text">
              © 2024 KATANA - Constructor de Ingresos Residuales Perpetuos
            </p>
          </div>
        </div>
      </footer>

      <WhatsAppButton
        phoneNumber={userdata?.whatsapp}
        message="Hola, me gustaría obtener más información."
        onContactClick={trackContact}
      />
      
      <LandingChatbot />
      
      {hasAnySocialLink && (
        <SocialButtons
          pdfUrl={userdata?.pdf || undefined}
          facebookUrl={userdata?.facebook || undefined}
          instagramUrl={userdata?.instagram || undefined}
          linkedinUrl={userdata?.linkedin || undefined}
          tiktokUrl={userdata?.tiktok || undefined}
          calendlyUrl={userdata?.calendly || undefined}
          onContactClick={(network) => console.log(`Se hizo clic en ${network}`)}
        />
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
    color: "#333",
  },
  bannerContent: {
    maxWidth: "1200px",
    width: "100%",
    zIndex: 1,
    position: "relative",
  },
  bannerTitle: {
    fontSize: "clamp(28px, 5vw, 48px)",
    fontWeight: "bold",
    color: "#fff",
    marginBottom: "20px",
    textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
    lineHeight: "1.2",
    padding: "0 20px",
  },
  bannerSubtitle: {
    fontSize: "clamp(16px, 3vw, 24px)",
    color: "#fff",
    textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
    lineHeight: "1.6",
    maxWidth: "800px",
    margin: "0 auto 30px",
    padding: "0 20px",
  },
  bannerSection: {
    width: "100%",
    padding: "60px 20px",
    textAlign: "center",
    position: "relative",
    minHeight: "300px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    textAlign: "center",
    maxWidth: "1200px",
    width: "100%",
    margin: "0 auto",
    padding: "40px 20px",
    backgroundColor: "transparent",
  },
  videosGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "30px",
    marginTop: "40px",
  },
  videoCard: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
  },
  videoWrapper: {
    position: "relative",
    width: "100%",
    paddingTop: "56.25%", // 16:9 aspect ratio
  },
  videoButton: {
    padding: "15px 20px",
    backgroundColor: "#1890ff",
    color: "#fff",
    border: "none",
    borderRadius: "0 0 10px 10px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
    transition: "background-color 0.3s",
  },
};

export default RevelacionLanding;


